import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Log({ idProjet }) {
  const [logData, setLogData] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!idProjet) return;

    axios
      .get(`${apiUrl}/IHM/api/navettes.php?journal=${idProjet}`)
      .then((res) => {
        setLogData(res.data);
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération du log :", err);
      });
  }, [idProjet]);

  const etatLabels = {
    0: "Partiel",
    1: "En cours",
    2: "Terminés"
    
  };

  const allLogs = [...logData]
    .filter((entry) => entry.date_action)
    .sort((a, b) => new Date(b.date_action) - new Date(a.date_action));

  const formatDateLocal = (datetimeStr) => {
    const d = new Date(datetimeStr);
    return `${d.toLocaleDateString()}`;
  };

  return (
    <>
      <div className="grid">
        <div className="col-12 md:col-12 font-bold">
          <div className="py-0 border-round-sm surface-100 flex flex-column">
            Historiques des actions :
          </div>
        </div>
      </div>

      <div className="grid">
        <div className="col-12 md:col-12">
          {allLogs.map((entry, index) => (
            <div
              key={index}
              style={{
                padding: "10px",
                fontSize: "0.75rem",
                border: "1px solid #f3f4f6",
                background: "#f3f4f6",
                borderRadius: "5px",
                marginBottom: "2px",
              }}
            >
              <span>
                [{formatDateLocal(entry.date_action)}]{" "}
                {entry.type_action?.toUpperCase() === "INSERT"
                  ? "Insertion"
                  : null}
              </span>{" "}
              {entry.action_type?.toUpperCase() === "UPDATE" && (
                <span>
                  {entry.message?.includes("État modifié") ? (
                    <>
                      État : {etatLabels[entry.nouvelle_valeur] ?? entry.nouvelle_valeur} [
                      {entry.admin}]
                      {entry.note &&
                        entry.details.toLowerCase().includes("note") && (
                          <> Note : {entry.note}</>
                        )}
                    </>
                  ) :
                  entry.message ? (
                    <>
                      Note : {entry.nouvelle_valeur} [{entry.admin}]
                    </>
                  ) : entry.details ? (
                    <>
                      {entry.details} [{entry.admin}]
                    </>
                  ) : null}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
